// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(6 57 50 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(6 57 50 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e9ecef; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Open Sans; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #ced4da; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  html,
  body,
  #root {
    height: 100%;
  }

  body {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(103 116 142 / var(--tw-text-opacity, 1));
}

  html.dark body {
    background-color: #0b0f0e;
    --tw-text-opacity: 1;
    color: rgb(168 184 216 / var(--tw-text-opacity, 1));
  }

  html.dark {
    color-scheme: dark;
  }

  /* Avoid the stone-900 (#1C1917) look for dark mode */
  html.dark body {
    background-color: #0b0f0e;
    --tw-text-opacity: 1;
    color: rgb(203 211 218 / var(--tw-text-opacity, 1));
  }
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 1.5rem;
  padding-left: 1.5rem;
}
@media (min-width: 576px) {

  .container {
    max-width: 576px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 992px) {

  .container {
    max-width: 992px;
  }
}
@media (min-width: 1200px) {

  .container {
    max-width: 1200px;
  }
}
@media (min-width: 1320px) {

  .container {
    max-width: 1320px;
  }
}
a {
  letter-spacing: -0.025rem;
}
hr {
  margin: 1rem 0;
  border: 0;
  opacity: .25;
}
img {
  max-width: none;
}
label {
  display: inline-block;
}
p {
  line-height: 1.625;
  font-weight: 400;
  margin-bottom: 1rem;
}
small {
  font-size: .875em;
}
svg {
  display: inline;
}
table {
  border-collapse: inherit;
}
h1, h2, h3, h4, h5, h6 {
  margin-bottom: .5rem;
  color: #063922;
}
h1, h2, h3, h4 {
  letter-spacing: -0.05rem;
}
h1, h2, h3 {
  font-weight: 700;
}
h4, h5, h6 {
  font-weight: 600;
}
h1 {
  font-size: 3rem;
  line-height: 1.25;
}
h2 {
  font-size: 2.25rem;
  line-height: 1.3;
}
h3 {
  font-size: 1.875rem;
  line-height: 1.375;
}
h4 {
  font-size: 1.5rem;
  line-height: 1.375;
}
h5 {
  font-size: 1.25rem;
  line-height: 1.375;
}
h6 {
  font-size: 1rem;
  line-height: 1.625;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-right-40 {
  right: -10rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-16 {
  bottom: 4rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-8 {
  bottom: 2rem;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-4 {
  left: 1rem;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.right-24 {
  right: 6rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.top-0 {
  top: 0px;
}
.top-3 {
  top: 0.75rem;
}
.top-full {
  top: 100%;
}
.top-px {
  top: 1px;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-990 {
  z-index: 990;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-sticky {
  z-index: 1020;
}
.float-left {
  float: left;
}
.-m-6 {
  margin: -1.5rem;
}
.m-0 {
  margin: 0px;
}
.m-4 {
  margin: 1rem;
}
.-mx-3 {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.-mx-6 {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.mx-0\\.5 {
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-1\\.5 {
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.-mb-4 {
  margin-bottom: -1rem;
}
.-ml-12 {
  margin-left: -3rem;
}
.-ml-16 {
  margin-left: -4rem;
}
.-ml-6\\.92 {
  margin-left: -1.73rem;
}
.-ml-px {
  margin-left: -1px;
}
.-mr-32 {
  margin-right: -8rem;
}
.-mt-16 {
  margin-top: -4rem;
}
.-mt-48 {
  margin-top: -12rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-32 {
  margin-bottom: 8rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mr-6 {
  margin-right: 1.5rem;
}
.mr-auto {
  margin-right: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-0\\.54 {
  margin-top: 0.135rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-1\\.75 {
  margin-top: 0.4375rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-32 {
  margin-top: 8rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-18\\.5 {
  height: 4.625rem;
}
.h-2 {
  height: 0.5rem;
}
.h-20 {
  height: 5rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-4\\.92 {
  height: 1.23rem;
}
.h-40 {
  height: 10rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[500px\\] {
  height: 500px;
}
.h-\\[calc\\(100\\%-2rem\\)\\] {
  height: calc(100% - 2rem);
}
.h-\\[calc\\(100vh-220px\\)\\] {
  height: calc(100vh - 220px);
}
.h-\\[calc\\(100vh-8rem\\)\\] {
  height: calc(100vh - 8rem);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[calc\\(100dvh-6rem\\)\\] {
  max-height: calc(100dvh - 6rem);
}
.min-h-0 {
  min-height: 0px;
}
.min-h-50-screen {
  min-height: 50vh;
}
.min-h-6 {
  min-height: 1.5rem;
}
.min-h-75 {
  min-height: 18.75rem;
}
.min-h-75-screen {
  min-height: 75vh;
}
.min-h-\\[100px\\] {
  min-height: 100px;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.min-h-\\[40px\\] {
  min-height: 40px;
}
.min-h-\\[52px\\] {
  min-height: 52px;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-\\[calc\\(100vh-8rem\\)\\] {
  min-height: calc(100vh - 8rem);
}
.min-h-screen {
  min-height: 100vh;
}
.w-0 {
  width: 0px;
}
.w-1\\/100 {
  width: 1%;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-18\\.5 {
  width: 4.625rem;
}
.w-2 {
  width: 0.5rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/12 {
  width: 25%;
}
.w-3\\/5 {
  width: 60%;
}
.w-4 {
  width: 1rem;
}
.w-4\\.92 {
  width: 1.23rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-5\\.5 {
  width: 1.375rem;
}
.w-52 {
  width: 13rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-8\\/12 {
  width: 66.666667%;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[calc\\(100\\%-2rem\\)\\] {
  width: calc(100% - 2rem);
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-px {
  width: 1px;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-14 {
  min-width: 3.5rem;
}
.min-w-52 {
  min-width: 13rem;
}
.min-w-\\[180px\\] {
  min-width: 180px;
}
.min-w-full {
  min-width: 100%;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[960px\\] {
  max-width: 960px;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-0 {
  flex: 0 0 auto;
}
.flex-1 {
  flex: 1 1;
}
.flex-auto {
  flex: 1 1 auto;
}
.flex-none {
  flex: none;
}
.flex-shrink {
  flex-shrink: 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.basis-full {
  flex-basis: 100%;
}
.table-auto {
  table-layout: auto;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-5 {
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-px {
  --tw-translate-x: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-4 {
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-skew-x-10 {
  --tw-skew-x: -10deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.skew-x-10 {
  --tw-skew-x: 10deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes ping {

  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.touch-none {
  touch-action: none;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize {
  resize: both;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(233 236 239 / var(--tw-divide-opacity, 1));
}
.divide-slate-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(203 211 218 / var(--tw-divide-opacity, 1));
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-1\\.4 {
  border-radius: 0.35rem;
}
.rounded-10 {
  border-radius: 2.5rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-blur {
  border-radius: 40px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-xs {
  border-radius: 0.0625rem;
}
.rounded-b-xl {
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-bl-xl {
  border-bottom-left-radius: 0.75rem;
}
.rounded-br-none {
  border-bottom-right-radius: 0px;
}
.rounded-tr-none {
  border-top-right-radius: 0px;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-r-0 {
  border-right-width: 0px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-emerald-600 {
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity, 1));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(235 239 244 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(233 236 239 / var(--tw-border-opacity, 1));
}
.border-gray-200\\/70 {
  border-color: rgb(233 236 239 / 0.7);
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(210 214 218 / var(--tw-border-opacity, 1));
}
.border-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(248 249 250 / var(--tw-border-opacity, 1));
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(6 57 50 / var(--tw-border-opacity, 1));
}
.border-primary-400 {
  --tw-border-opacity: 1;
  border-color: rgb(6 57 50 / var(--tw-border-opacity, 1));
}
.border-primary-500 {
  --tw-border-opacity: 1;
  border-color: rgb(6 57 50 / var(--tw-border-opacity, 1));
}
.border-primary-600 {
  --tw-border-opacity: 1;
  border-color: rgb(6 57 50 / var(--tw-border-opacity, 1));
}
.border-primary\\/20 {
  border-color: rgb(6 57 50 / 0.2);
}
.border-primary\\/50 {
  border-color: rgb(6 57 50 / 0.5);
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-slate-100 {
  --tw-border-opacity: 1;
  border-color: rgb(222 226 230 / var(--tw-border-opacity, 1));
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(203 211 218 / var(--tw-border-opacity, 1));
}
.border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(168 184 216 / var(--tw-border-opacity, 1));
}
.border-slate-500 {
  --tw-border-opacity: 1;
  border-color: rgb(103 116 142 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-warning {
  --tw-border-opacity: 1;
  border-color: rgb(236 141 24 / var(--tw-border-opacity, 1));
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(33 82 255 / var(--tw-bg-opacity, 1));
}
.bg-danger {
  --tw-bg-opacity: 1;
  background-color: rgb(255 0 0 / var(--tw-bg-opacity, 1));
}
.bg-danger\\/10 {
  background-color: rgb(255 0 0 / 0.1);
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-emerald-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(235 239 244 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(210 214 218 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(108 117 125 / var(--tw-bg-opacity, 1));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(6 57 50 / var(--tw-bg-opacity, 1));
}
.bg-primary-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(162 185 181 / var(--tw-bg-opacity, 1));
}
.bg-primary-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(162 185 181 / var(--tw-bg-opacity, 1));
}
.bg-primary-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 57 50 / var(--tw-bg-opacity, 1));
}
.bg-primary-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 57 50 / var(--tw-bg-opacity, 1));
}
.bg-primary-light\\/40 {
  background-color: rgb(162 185 181 / 0.4);
}
.bg-primary\\/10 {
  background-color: rgb(6 57 50 / 0.1);
}
.bg-primary\\/5 {
  background-color: rgb(6 57 50 / 0.05);
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 6 6 / var(--tw-bg-opacity, 1));
}
.bg-sky-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(222 226 230 / var(--tw-bg-opacity, 1));
}
.bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 211 218 / var(--tw-bg-opacity, 1));
}
.bg-slate-200\\/50 {
  background-color: rgb(203 211 218 / 0.5);
}
.bg-slate-300\\/40 {
  background-color: rgb(168 184 216 / 0.4);
}
.bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(58 65 111 / var(--tw-bg-opacity, 1));
}
.bg-slate-800\\/10 {
  background-color: rgb(58 65 111 / 0.1);
}
.bg-transparent {
  background-color: transparent;
}
.bg-warning {
  --tw-bg-opacity: 1;
  background-color: rgb(236 141 24 / var(--tw-bg-opacity, 1));
}
.bg-warning\\/10 {
  background-color: rgb(236 141 24 / 0.1);
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/75 {
  background-color: rgb(255 255 255 / 0.75);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/95 {
  background-color: rgb(255 255 255 / 0.95);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-tl {
  background-image: linear-gradient(to top left, var(--tw-gradient-stops));
}
.bg-none {
  background-image: none;
}
.from-emerald-800 {
  --tw-gradient-from: #065f46 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 95 70 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-900 {
  --tw-gradient-from: #141727 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 23 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary {
  --tw-gradient-from: #063932 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 57 50 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white {
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-black\\/40 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-primary-dark {
  --tw-gradient-to: rgb(107 187 177 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #6BBBB1 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-200 {
  --tw-gradient-to: rgb(203 211 218 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #cbd3da var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#6BBBB1\\] {
  --tw-gradient-to: #6BBBB1 var(--tw-gradient-to-position);
}
.to-emerald-600 {
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}
.to-gray-50 {
  --tw-gradient-to: #f8f9fa var(--tw-gradient-to-position);
}
.to-primary-dark {
  --tw-gradient-to: #6BBBB1 var(--tw-gradient-to-position);
}
.to-slate-800 {
  --tw-gradient-to: #3a416f var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-150 {
  background-size: 150%;
}
.bg-contain {
  background-size: contain;
}
.bg-cover {
  background-size: cover;
}
.bg-clip-border {
  background-clip: border-box;
}
.bg-clip-padding {
  background-clip: padding-box;
}
.bg-center {
  background-position: center;
}
.bg-left {
  background-position: left;
}
.bg-x-25 {
  background-position: 25% 0;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.stroke-0 {
  stroke-width: 0;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-7 {
  padding: 1.75rem;
}
.p-8 {
  padding: 2rem;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.375 {
  padding-top: .59375rem;
  padding-bottom: .59375rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-2\\.7 {
  padding-top: 0.675rem;
  padding-bottom: 0.675rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-32 {
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-56 {
  padding-bottom: 14rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-12 {
  padding-left: 3rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-6\\.92 {
  padding-left: 1.73rem;
}
.pl-8\\.75 {
  padding-left: 2.1875rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.ps-2 {
  padding-inline-start: 0.5rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.align-baseline {
  vertical-align: baseline;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.font-sans {
  font-family: Open Sans;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-inherit {
  font-size: inherit;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.5rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.leading-5\\.6 {
  line-height: 1.4rem;
}
.leading-default {
  line-height: 1.6;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-pro {
  line-height: 1.4;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-tight-soft {
  letter-spacing: -0.025rem;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-danger {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity, 1));
}
.text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(233 236 239 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(173 181 189 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(108 117 125 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(73 80 87 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(37 47 64 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(20 23 39 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(23 173 55 / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-inherit {
  color: inherit;
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(6 57 50 / var(--tw-text-opacity, 1));
}
.text-primary-600 {
  --tw-text-opacity: 1;
  color: rgb(6 57 50 / var(--tw-text-opacity, 1));
}
.text-primary-700 {
  --tw-text-opacity: 1;
  color: rgb(6 57 50 / var(--tw-text-opacity, 1));
}
.text-primary-800 {
  --tw-text-opacity: 1;
  color: rgb(107 187 177 / var(--tw-text-opacity, 1));
}
.text-primary-900 {
  --tw-text-opacity: 1;
  color: rgb(10 24 14 / var(--tw-text-opacity, 1));
}
.text-primary-dark {
  --tw-text-opacity: 1;
  color: rgb(107 187 177 / var(--tw-text-opacity, 1));
}
.text-primary-ink {
  --tw-text-opacity: 1;
  color: rgb(10 24 14 / var(--tw-text-opacity, 1));
}
.text-primary-light {
  --tw-text-opacity: 1;
  color: rgb(162 185 181 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(245 57 57 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(234 6 6 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-sky-700 {
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}
.text-slate-200 {
  --tw-text-opacity: 1;
  color: rgb(203 211 218 / var(--tw-text-opacity, 1));
}
.text-slate-300 {
  --tw-text-opacity: 1;
  color: rgb(168 184 216 / var(--tw-text-opacity, 1));
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(131 146 171 / var(--tw-text-opacity, 1));
}
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(103 116 142 / var(--tw-text-opacity, 1));
}
.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(98 117 148 / var(--tw-text-opacity, 1));
}
.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(6 57 34 / var(--tw-text-opacity, 1));
}
.text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(58 65 111 / var(--tw-text-opacity, 1));
}
.text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-warning {
  --tw-text-opacity: 1;
  color: rgb(236 141 24 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/60 {
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.placeholder-gray-500::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(173 181 189 / var(--tw-placeholder-opacity, 1));
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-soft-2xl {
  --tw-shadow: 0 .3125rem .625rem 0 rgba(0,0,0,.12);
  --tw-shadow-colored: 0 .3125rem .625rem 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-soft-md {
  --tw-shadow: 0 4px 7px -1px rgba(0,0,0,.11),0 2px 4px -1px rgba(0,0,0,.07);
  --tw-shadow-colored: 0 4px 7px -1px var(--tw-shadow-color), 0 2px 4px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-soft-xl {
  --tw-shadow: 0 20px 27px 0 rgba(0,0,0,0.05);
  --tw-shadow-colored: 0 20px 27px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 23px 45px -11px hsla(0,0%,8%,.25);
  --tw-shadow-colored: 0 23px 45px -11px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-primary\\/20 {
  --tw-shadow-color: rgb(6 57 50 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary\\/25 {
  --tw-shadow-color: rgb(6 57 50 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-200\\/50 {
  --tw-shadow-color: rgb(203 211 218 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black\\/5 {
  --tw-ring-color: rgb(0 0 0 / 0.05);
}
.ring-primary-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 57 50 / var(--tw-ring-opacity, 1));
}
.ring-offset-2 {
  --tw-ring-offset-width: 2px;
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-2xl {
  --tw-backdrop-blur: blur(30px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-saturate-150 {
  --tw-backdrop-saturate: saturate(1.5);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-saturate-200 {
  --tw-backdrop-saturate: saturate(2);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter {
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-250 {
  transition-duration: 250ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-350 {
  transition-duration: 350ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-soft {
  transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
}
.ease-soft-in {
  transition-timing-function: cubic-bezier(0.42, 0, 1, 1);
}
.ease-soft-in-out {
  transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
}
.flex-wrap-inherit {
  flex-wrap: inherit;
}
/* Dashboard card surface: white in light mode, fully transparent in dark mode (uses body bg). */
.dashboard-card {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
html.dark .dashboard-card {
  --tw-bg-opacity: 1;
  background-color: rgb(41 37 36 / var(--tw-bg-opacity, 1));
}
html.dark .dashboard-card .bg-primary-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 187 177 / var(--tw-bg-opacity, 1));
}
html.dark .dashboard-card .text-primary-600,
  html.dark .dashboard-card .text-primary-700 {
  --tw-text-opacity: 1;
  color: rgb(107 187 177 / var(--tw-text-opacity, 1));
}
html.dark .dashboard-card .border-primary-600 {
  --tw-border-opacity: 1;
  border-color: rgb(107 187 177 / var(--tw-border-opacity, 1));
}
html.dark .dashboard-card .bg-primary\\/10 {
  background-color: rgb(107 187 177 / 0.2);
}
html.dark .dashboard-card {
  background-color: rgb(41 37 36 / 0.3);
}
html.dark .bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(41 37 36 / var(--tw-bg-opacity, 1));
}
html.dark .bg-gray-50 {
    background-color: #0b0f0e;
  }
html.dark .text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(222 226 230 / var(--tw-text-opacity, 1));
}
html.dark .text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(203 211 218 / var(--tw-text-opacity, 1));
}
html.dark .text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(168 184 216 / var(--tw-text-opacity, 1));
}
html.dark .text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(235 239 244 / var(--tw-text-opacity, 1));
}
html.dark .border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(73 80 87 / var(--tw-border-opacity, 1));
}
html.dark .border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(73 80 87 / var(--tw-border-opacity, 1));
}
html.dark .border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(108 117 125 / var(--tw-border-opacity, 1));
}
html.dark .bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.1);
}
html.dark .hover\\:bg-white\\/60:hover {
  background-color: rgb(255 255 255 / 0.1);
}
html.dark .hover\\:bg-slate-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(68 64 60 / var(--tw-bg-opacity, 1));
}
html.dark .hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(68 64 60 / var(--tw-bg-opacity, 1));
}
/* Brand green on dark cards: bump "primary" surfaces to the brighter mint variant so they don't disappear. */
html.dark .bg-white .bg-primary-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 187 177 / var(--tw-bg-opacity, 1));
}
html.dark .bg-white .text-primary-600,
  html.dark .bg-white .text-primary-700 {
  --tw-text-opacity: 1;
  color: rgb(107 187 177 / var(--tw-text-opacity, 1));
}
html.dark .bg-white .border-primary-600 {
  --tw-border-opacity: 1;
  border-color: rgb(107 187 177 / var(--tw-border-opacity, 1));
}
/* Subtle primary tints: make them visible on dark card surfaces. */
html.dark .bg-white .bg-primary\\/10 {
  background-color: rgb(107 187 177 / 0.2);
}
/* Scrollbar styling (applied via .clicklaw-scrollbar) */
.clicklaw-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: rgba(148, 163, 184, 0.7) transparent; /* slate-400-ish */
  }
.clicklaw-scrollbar::-webkit-scrollbar {
    width: 10px;
  }
.clicklaw-scrollbar::-webkit-scrollbar-track {
    background: transparent;
  }
.clicklaw-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(148, 163, 184, 0.6);
    border-radius: 9999px;
    border: 3px solid transparent;
    background-clip: content-box;
  }
.clicklaw-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(148, 163, 184, 0.85);
  }
html.dark .clicklaw-scrollbar {
    scrollbar-color: rgba(203, 213, 225, 0.45) transparent; /* slate-200-ish */
  }
html.dark .clicklaw-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(203, 213, 225, 0.35);
  }
html.dark .clicklaw-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(203, 213, 225, 0.55);
  }

/* Pragmatic dark-mode defaults for common light-only utility classes used across the app. */
.file\\:mr-2::file-selector-button {
  margin-right: 0.5rem;
}
.file\\:rounded::file-selector-button {
  border-radius: 0.25rem;
}
.file\\:border-0::file-selector-button {
  border-width: 0px;
}
.file\\:bg-slate-100::file-selector-button {
  --tw-bg-opacity: 1;
  background-color: rgb(222 226 230 / var(--tw-bg-opacity, 1));
}
.file\\:px-3::file-selector-button {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.file\\:py-1\\.5::file-selector-button {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.file\\:text-slate-700::file-selector-button {
  --tw-text-opacity: 1;
  color: rgb(6 57 34 / var(--tw-text-opacity, 1));
}
html.dark .file\\:text-slate-700::file-selector-button {
  --tw-text-opacity: 1;
  color: rgb(222 226 230 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-gray-500::placeholder {
  --tw-text-opacity: 1;
  color: rgb(173 181 189 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-slate-500::placeholder {
  --tw-text-opacity: 1;
  color: rgb(103 116 142 / var(--tw-text-opacity, 1));
}
html.dark .placeholder\\:text-slate-500::placeholder {
  --tw-text-opacity: 1;
  color: rgb(168 184 216 / var(--tw-text-opacity, 1));
}
.before\\:float-left::before {
  content: var(--tw-content);
  float: left;
}
.before\\:pr-2::before {
  content: var(--tw-content);
  padding-right: 0.5rem;
}
.before\\:text-gray-500::before {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(173 181 189 / var(--tw-text-opacity, 1));
}
.before\\:content-\\[\\'\\/\\'\\]::before {
  --tw-content: '/';
  content: var(--tw-content);
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:top-px::after {
  content: var(--tw-content);
  top: 1px;
}
.after\\:flex::after {
  content: var(--tw-content);
  display: flex;
}
.after\\:h-4::after {
  content: var(--tw-content);
  height: 1rem;
}
.after\\:h-full::after {
  content: var(--tw-content);
  height: 100%;
}
.after\\:w-4::after {
  content: var(--tw-content);
  width: 1rem;
}
.after\\:w-full::after {
  content: var(--tw-content);
  width: 100%;
}
.after\\:translate-x-px::after {
  content: var(--tw-content);
  --tw-translate-x: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:items-center::after {
  content: var(--tw-content);
  align-items: center;
}
.after\\:justify-center::after {
  content: var(--tw-content);
  justify-content: center;
}
.after\\:rounded-circle::after {
  content: var(--tw-content);
  border-radius: 50%;
}
.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.after\\:font-awesome::after {
  content: var(--tw-content);
  font-family: FontAwesome;
}
.after\\:text-xxs::after {
  content: var(--tw-content);
  font-size: 0.65rem;
  line-height: 1rem;
}
.after\\:text-white::after {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.after\\:opacity-0::after {
  content: var(--tw-content);
  opacity: 0;
}
.after\\:shadow-soft-2xl::after {
  content: var(--tw-content);
  --tw-shadow: 0 .3125rem .625rem 0 rgba(0,0,0,.12);
  --tw-shadow-colored: 0 .3125rem .625rem 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:duration-250::after {
  content: var(--tw-content);
  transition-duration: 250ms;
}
.after\\:ease-soft-in-out::after {
  content: var(--tw-content);
  transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
}
.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.after\\:content-\\[\\'\\\\f00c\\'\\]::after {
  --tw-content: '\\f00c';
  content: var(--tw-content);
}
html.dark .after\\:bg-white::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(41 37 36 / var(--tw-bg-opacity, 1));
  }
html.dark .after\\:bg-white .bg-primary-700::after {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(107 187 177 / var(--tw-bg-opacity, 1));
  }
html.dark .after\\:bg-white .text-primary-600::after,
  html.dark .after\\:bg-white .text-primary-700::after {
    content: var(--tw-content);
    --tw-text-opacity: 1;
    color: rgb(107 187 177 / var(--tw-text-opacity, 1));
  }
html.dark .after\\:bg-white .border-primary-600::after {
    content: var(--tw-content);
    --tw-border-opacity: 1;
    border-color: rgb(107 187 177 / var(--tw-border-opacity, 1));
  }
html.dark .after\\:bg-white .bg-primary\\/10::after {
    content: var(--tw-content);
    background-color: rgb(107 187 177 / 0.2);
  }
.first\\:mt-0:first-child {
  margin-top: 0px;
}
.last\\:mb-0:last-child {
  margin-bottom: 0px;
}
.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
.even\\:bg-slate-50:nth-child(even) {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.checked\\:border-0:checked {
  border-width: 0px;
}
.checked\\:border-slate-800\\/95:checked {
  border-color: rgb(58 65 111 / 0.95);
}
.checked\\:border-transparent:checked {
  border-color: transparent;
}
.checked\\:bg-slate-800\\/95:checked {
  background-color: rgb(58 65 111 / 0.95);
}
.checked\\:bg-transparent:checked {
  background-color: transparent;
}
.checked\\:bg-gradient-to-tl:checked {
  background-image: linear-gradient(to top left, var(--tw-gradient-stops));
}
.checked\\:bg-none:checked {
  background-image: none;
}
.checked\\:from-gray-900:checked {
  --tw-gradient-from: #141727 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 23 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.checked\\:to-slate-800:checked {
  --tw-gradient-to: #3a416f var(--tw-gradient-to-position);
}
.checked\\:bg-right:checked {
  background-position: right;
}
.checked\\:after\\:translate-x-5\\.25:checked::after {
  content: var(--tw-content);
  --tw-translate-x: 1.3125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.checked\\:after\\:opacity-100:checked::after {
  content: var(--tw-content);
  opacity: 1;
}
.hover\\:scale-102:hover {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-amber-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.hover\\:border-primary:hover {
  --tw-border-opacity: 1;
  border-color: rgb(6 57 50 / var(--tw-border-opacity, 1));
}
.hover\\:border-primary-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(162 185 181 / var(--tw-border-opacity, 1));
}
.hover\\:border-primary-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(6 57 50 / var(--tw-border-opacity, 1));
}
.hover\\:border-primary\\/30:hover {
  border-color: rgb(6 57 50 / 0.3);
}
.hover\\:border-primary\\/40:hover {
  border-color: rgb(6 57 50 / 0.4);
}
.hover\\:border-slate-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(168 184 216 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(131 146 171 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-700:hover {
  --tw-border-opacity: 1;
  border-color: rgb(6 57 34 / var(--tw-border-opacity, 1));
}
.hover\\:bg-amber-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(235 239 244 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100\\/50:hover {
  background-color: rgb(235 239 244 / 0.5);
}
.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 250 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(6 57 50 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(162 185 181 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(6 57 50 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 187 177 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary-ink:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(10 24 14 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-primary\\/90:hover {
  background-color: rgb(6 57 50 / 0.9);
}
.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(222 226 230 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(203 211 218 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(168 184 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(6 57 34 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-transparent:hover {
  background-color: transparent;
}
.hover\\:bg-warning:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 141 24 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/60:hover {
  background-color: rgb(255 255 255 / 0.6);
}
.hover\\:text-danger:hover {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(73 80 87 / var(--tw-text-opacity, 1));
}
.hover\\:text-primary:hover {
  --tw-text-opacity: 1;
  color: rgb(6 57 50 / var(--tw-text-opacity, 1));
}
.hover\\:text-primary-600:hover {
  --tw-text-opacity: 1;
  color: rgb(6 57 50 / var(--tw-text-opacity, 1));
}
.hover\\:text-primary-700:hover {
  --tw-text-opacity: 1;
  color: rgb(6 57 50 / var(--tw-text-opacity, 1));
}
.hover\\:text-primary-800:hover {
  --tw-text-opacity: 1;
  color: rgb(107 187 177 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-600:hover {
  --tw-text-opacity: 1;
  color: rgb(98 117 148 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-700:hover {
  --tw-text-opacity: 1;
  color: rgb(6 57 34 / var(--tw-text-opacity, 1));
}
.hover\\:text-slate-900:hover {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:opacity-75:hover {
  opacity: 0.75;
}
.hover\\:opacity-80:hover {
  opacity: 0.8;
}
.hover\\:opacity-90:hover {
  opacity: 0.9;
}
.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-sm:hover {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-soft-xs:hover {
  --tw-shadow: 0 3px 5px -1px rgba(0,0,0,.09),0 2px 3px -1px rgba(0,0,0,.07);
  --tw-shadow-colored: 0 3px 5px -1px var(--tw-shadow-color), 0 2px 3px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
html.dark .hover\\:bg-gray-50:hover {
    background-color: #0b0f0e;
  }
html.dark .hover\\:text-slate-700:hover {
  --tw-text-opacity: 1;
  color: rgb(222 226 230 / var(--tw-text-opacity, 1));
}
html.dark .hover\\:text-slate-600:hover {
  --tw-text-opacity: 1;
  color: rgb(203 211 218 / var(--tw-text-opacity, 1));
}
html.dark .hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(235 239 244 / var(--tw-text-opacity, 1));
}
html.dark .bg-white .hover\\:bg-primary-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 187 177 / var(--tw-bg-opacity, 1));
}
html.dark .bg-white .hover\\:text-primary-600:hover {
  --tw-text-opacity: 1;
  color: rgb(107 187 177 / var(--tw-text-opacity, 1));
}

  html.dark .bg-white .hover\\:text-primary-700:hover {
  --tw-text-opacity: 1;
  color: rgb(107 187 177 / var(--tw-text-opacity, 1));
}
.focus\\:border-primary:focus {
  --tw-border-opacity: 1;
  border-color: rgb(6 57 50 / var(--tw-border-opacity, 1));
}
.focus\\:border-primary-300:focus {
  --tw-border-opacity: 1;
  border-color: rgb(162 185 181 / var(--tw-border-opacity, 1));
}
.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.focus\\:shadow-soft-primary-outline:focus {
  --tw-shadow: 0 0 0 2px #A2B9B5;
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-primary:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 57 50 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-primary-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 57 50 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 57 57 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
.focus\\:transition-shadow:focus {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
html.dark .focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(41 37 36 / var(--tw-bg-opacity, 1));
}
html.dark .focus\\:bg-white:focus .bg-primary-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 187 177 / var(--tw-bg-opacity, 1));
}
html.dark .focus\\:bg-white:focus .text-primary-600,
  html.dark .focus\\:bg-white:focus .text-primary-700 {
  --tw-text-opacity: 1;
  color: rgb(107 187 177 / var(--tw-text-opacity, 1));
}
html.dark .focus\\:bg-white:focus .border-primary-600 {
  --tw-border-opacity: 1;
  border-color: rgb(107 187 177 / var(--tw-border-opacity, 1));
}
html.dark .focus\\:bg-white:focus .bg-primary\\/10 {
  background-color: rgb(107 187 177 / 0.2);
}
.active\\:scale-\\[0\\.98\\]:active {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:opacity-85:active {
  opacity: 0.85;
}
.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}
.disabled\\:hover\\:bg-transparent:hover:disabled {
  background-color: transparent;
}
.group:hover .group-hover\\:text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-primary {
  --tw-text-opacity: 1;
  color: rgb(6 57 50 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-primary-600 {
  --tw-text-opacity: 1;
  color: rgb(6 57 50 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
html.dark .bg-white .group:hover .group-hover\\:text-primary-600 {
  --tw-text-opacity: 1;
  color: rgb(107 187 177 / var(--tw-text-opacity, 1));
}
@supports (backdrop-filter: var(--tw)) {

  .supports-\\[backdrop-filter\\]\\:bg-white\\/60 {
    background-color: rgb(255 255 255 / 0.6);
  }
}
@media (prefers-reduced-motion: reduce) {

  .motion-reduce\\:animate-none {
    animation: none;
  }
}
.dark\\:divide-gray-600:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(108 117 125 / var(--tw-divide-opacity, 1));
}
.dark\\:divide-slate-600\\/50:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(98 117 148 / 0.5);
}
.dark\\:divide-slate-800:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(58 65 111 / var(--tw-divide-opacity, 1));
}
.dark\\:border-amber-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(180 83 9 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(108 117 125 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(73 80 87 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(37 47 64 / var(--tw-border-opacity, 1));
}
.dark\\:border-primary-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(6 57 50 / var(--tw-border-opacity, 1));
}
.dark\\:border-primary\\/30:is(.dark *) {
  border-color: rgb(6 57 50 / 0.3);
}
.dark\\:border-red-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity, 1));
}
.dark\\:border-slate-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(98 117 148 / var(--tw-border-opacity, 1));
}
.dark\\:border-slate-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(6 57 34 / var(--tw-border-opacity, 1));
}
.dark\\:border-slate-700\\/50:is(.dark *) {
  border-color: rgb(6 57 34 / 0.5);
}
.dark\\:border-slate-700\\/60:is(.dark *) {
  border-color: rgb(6 57 34 / 0.6);
}
.dark\\:border-slate-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(58 65 111 / var(--tw-border-opacity, 1));
}
.dark\\:border-stone-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(87 83 78 / var(--tw-border-opacity, 1));
}
.dark\\:border-stone-600\\/50:is(.dark *) {
  border-color: rgb(87 83 78 / 0.5);
}
.dark\\:border-stone-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(68 64 60 / var(--tw-border-opacity, 1));
}
.dark\\:border-white\\/10:is(.dark *) {
  border-color: rgb(255 255 255 / 0.1);
}
.dark\\:bg-\\[\\#0b1120\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(11 17 32 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-amber-900\\/20:is(.dark *) {
  background-color: rgb(120 53 15 / 0.2);
}
.dark\\:bg-amber-900\\/30:is(.dark *) {
  background-color: rgb(120 53 15 / 0.3);
}
.dark\\:bg-black\\/60:is(.dark *) {
  background-color: rgb(0 0 0 / 0.6);
}
.dark\\:bg-blue-900\\/20:is(.dark *) {
  background-color: rgb(0 0 125 / 0.2);
}
.dark\\:bg-blue-900\\/30:is(.dark *) {
  background-color: rgb(0 0 125 / 0.3);
}
.dark\\:bg-blue-900\\/40:is(.dark *) {
  background-color: rgb(0 0 125 / 0.4);
}
.dark\\:bg-emerald-400\\/20:is(.dark *) {
  background-color: rgb(52 211 153 / 0.2);
}
.dark\\:bg-emerald-900\\/30:is(.dark *) {
  background-color: rgb(6 78 59 / 0.3);
}
.dark\\:bg-green-900\\/40:is(.dark *) {
  background-color: rgb(20 83 45 / 0.4);
}
.dark\\:bg-primary-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(6 57 50 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-primary-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(6 57 50 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-primary-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(6 57 50 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-primary-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 187 177 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-primary-900\\/20:is(.dark *) {
  background-color: rgb(10 24 14 / 0.2);
}
.dark\\:bg-primary-900\\/40:is(.dark *) {
  background-color: rgb(10 24 14 / 0.4);
}
.dark\\:bg-primary\\/10:is(.dark *) {
  background-color: rgb(6 57 50 / 0.1);
}
.dark\\:bg-primary\\/20:is(.dark *) {
  background-color: rgb(6 57 50 / 0.2);
}
.dark\\:bg-red-900\\/20:is(.dark *) {
  background-color: rgb(127 29 29 / 0.2);
}
.dark\\:bg-red-900\\/30:is(.dark *) {
  background-color: rgb(127 29 29 / 0.3);
}
.dark\\:bg-slate-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(203 211 218 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-500\\/30:is(.dark *) {
  background-color: rgb(103 116 142 / 0.3);
}
.dark\\:bg-slate-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(98 117 148 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(6 57 34 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-700\\/30:is(.dark *) {
  background-color: rgb(6 57 34 / 0.3);
}
.dark\\:bg-slate-700\\/40:is(.dark *) {
  background-color: rgb(6 57 34 / 0.4);
}
.dark\\:bg-slate-700\\/50:is(.dark *) {
  background-color: rgb(6 57 34 / 0.5);
}
.dark\\:bg-slate-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(58 65 111 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-800\\/50:is(.dark *) {
  background-color: rgb(58 65 111 / 0.5);
}
.dark\\:bg-slate-800\\/60:is(.dark *) {
  background-color: rgb(58 65 111 / 0.6);
}
.dark\\:bg-slate-800\\/70:is(.dark *) {
  background-color: rgb(58 65 111 / 0.7);
}
.dark\\:bg-slate-800\\/80:is(.dark *) {
  background-color: rgb(58 65 111 / 0.8);
}
.dark\\:bg-slate-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-900\\/30:is(.dark *) {
  background-color: rgb(15 23 42 / 0.3);
}
.dark\\:bg-slate-900\\/40:is(.dark *) {
  background-color: rgb(15 23 42 / 0.4);
}
.dark\\:bg-slate-900\\/80:is(.dark *) {
  background-color: rgb(15 23 42 / 0.8);
}
.dark\\:bg-stone-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(87 83 78 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-stone-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(68 64 60 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-stone-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(41 37 36 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-stone-800\\/60:is(.dark *) {
  background-color: rgb(41 37 36 / 0.6);
}
.dark\\:bg-stone-800\\/75:is(.dark *) {
  background-color: rgb(41 37 36 / 0.75);
}
.dark\\:bg-stone-800\\/80:is(.dark *) {
  background-color: rgb(41 37 36 / 0.8);
}
.dark\\:bg-stone-800\\/95:is(.dark *) {
  background-color: rgb(41 37 36 / 0.95);
}
.dark\\:bg-stone-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(28 25 23 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-transparent:is(.dark *) {
  background-color: transparent;
}
.dark\\:bg-yellow-900\\/30:is(.dark *) {
  background-color: rgb(113 63 18 / 0.3);
}
.dark\\:from-slate-800:is(.dark *) {
  --tw-gradient-from: #3a416f var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(58 65 111 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:via-stone-700:is(.dark *) {
  --tw-gradient-to: rgb(68 64 60 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #44403c var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.dark\\:via-white\\/20:is(.dark *) {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.dark\\:to-slate-900:is(.dark *) {
  --tw-gradient-to: #0f172a var(--tw-gradient-to-position);
}
.dark\\:text-amber-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}
.dark\\:text-amber-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(233 236 239 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.dark\\:text-primary-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(162 185 181 / var(--tw-text-opacity, 1));
}
.dark\\:text-primary-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(162 185 181 / var(--tw-text-opacity, 1));
}
.dark\\:text-primary-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(107 187 177 / var(--tw-text-opacity, 1));
}
.dark\\:text-primary-dark:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(107 187 177 / var(--tw-text-opacity, 1));
}
.dark\\:text-primary-light:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(162 185 181 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(222 226 230 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(203 211 218 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(168 184 216 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(131 146 171 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(103 116 142 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(98 117 148 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.dark\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:text-yellow-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 207 51 / var(--tw-text-opacity, 1));
}
.dark\\:placeholder-slate-400:is(.dark *)::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(131 146 171 / var(--tw-placeholder-opacity, 1));
}
.dark\\:opacity-90:is(.dark *) {
  opacity: 0.9;
}
.dark\\:shadow-primary\\/20:is(.dark *) {
  --tw-shadow-color: rgb(6 57 50 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.dark\\:ring-white\\/10:is(.dark *) {
  --tw-ring-color: rgb(255 255 255 / 0.1);
}
html.dark .dark\\:text-slate-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(203 211 218 / var(--tw-text-opacity, 1));
}
html.dark .dark\\:text-slate-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(168 184 216 / var(--tw-text-opacity, 1));
}
html.dark .bg-white .dark\\:bg-primary-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 187 177 / var(--tw-bg-opacity, 1));
}
html.dark .bg-white .dark\\:bg-primary\\/10:is(.dark *) {
  background-color: rgb(107 187 177 / 0.2);
}
.dark\\:file\\:bg-slate-700:is(.dark *)::file-selector-button {
  --tw-bg-opacity: 1;
  background-color: rgb(6 57 34 / var(--tw-bg-opacity, 1));
}
.dark\\:file\\:text-slate-200:is(.dark *)::file-selector-button {
  --tw-text-opacity: 1;
  color: rgb(203 211 218 / var(--tw-text-opacity, 1));
}
.dark\\:placeholder\\:text-slate-400:is(.dark *)::placeholder {
  --tw-text-opacity: 1;
  color: rgb(131 146 171 / var(--tw-text-opacity, 1));
}
.dark\\:before\\:text-slate-500:is(.dark *)::before {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(103 116 142 / var(--tw-text-opacity, 1));
}
html.dark .dark\\:before\\:text-slate-500:is(.dark *)::before {
    content: var(--tw-content);
    --tw-text-opacity: 1;
    color: rgb(168 184 216 / var(--tw-text-opacity, 1));
  }
.dark\\:even\\:bg-white\\/5:nth-child(even):is(.dark *) {
  background-color: rgb(255 255 255 / 0.05);
}
.dark\\:hover\\:border-primary-400:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(6 57 50 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:border-primary-dark:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(107 187 177 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:border-primary-dark\\/30:hover:is(.dark *) {
  border-color: rgb(107 187 177 / 0.3);
}
.dark\\:hover\\:border-primary-dark\\/40:hover:is(.dark *) {
  border-color: rgb(107 187 177 / 0.4);
}
.dark\\:hover\\:border-primary\\/40:hover:is(.dark *) {
  border-color: rgb(6 57 50 / 0.4);
}
.dark\\:hover\\:border-slate-500:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(103 116 142 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:border-slate-600:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(98 117 148 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:bg-amber-900\\/50:hover:is(.dark *) {
  background-color: rgb(120 53 15 / 0.5);
}
.dark\\:hover\\:bg-primary-500:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(6 57 50 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-primary-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(6 57 50 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-primary-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 187 177 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-primary-800\\/50:hover:is(.dark *) {
  background-color: rgb(107 187 177 / 0.5);
}
.dark\\:hover\\:bg-primary-900\\/60:hover:is(.dark *) {
  background-color: rgb(10 24 14 / 0.6);
}
.dark\\:hover\\:bg-red-900\\/20:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.2);
}
.dark\\:hover\\:bg-red-900\\/30:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.3);
}
.dark\\:hover\\:bg-slate-500:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(103 116 142 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-slate-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(98 117 148 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-slate-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(6 57 34 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-slate-700\\/30:hover:is(.dark *) {
  background-color: rgb(6 57 34 / 0.3);
}
.dark\\:hover\\:bg-slate-700\\/50:hover:is(.dark *) {
  background-color: rgb(6 57 34 / 0.5);
}
.dark\\:hover\\:bg-slate-700\\/70:hover:is(.dark *) {
  background-color: rgb(6 57 34 / 0.7);
}
.dark\\:hover\\:bg-slate-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(58 65 111 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-slate-800\\/60:hover:is(.dark *) {
  background-color: rgb(58 65 111 / 0.6);
}
.dark\\:hover\\:bg-slate-800\\/80:hover:is(.dark *) {
  background-color: rgb(58 65 111 / 0.8);
}
.dark\\:hover\\:bg-stone-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(87 83 78 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-stone-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(68 64 60 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-white\\/10:hover:is(.dark *) {
  background-color: rgb(255 255 255 / 0.1);
}
.dark\\:hover\\:bg-white\\/5:hover:is(.dark *) {
  background-color: rgb(255 255 255 / 0.05);
}
.dark\\:hover\\:text-danger:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-primary-700:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(6 57 50 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-primary-800:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(107 187 177 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-primary-dark:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(107 187 177 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-red-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-slate-100:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(222 226 230 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-slate-200:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(203 211 218 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-slate-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(168 184 216 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-white:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

  html.dark .bg-white .dark\\:hover\\:text-primary-700:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(107 187 177 / var(--tw-text-opacity, 1));
}
.dark\\:focus\\:border-primary-dark:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(107 187 177 / var(--tw-border-opacity, 1));
}
.dark\\:focus\\:bg-stone-800:focus:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(41 37 36 / var(--tw-bg-opacity, 1));
}
.group:hover .dark\\:group-hover\\:text-amber-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.group:hover .dark\\:group-hover\\:text-primary-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(6 57 50 / var(--tw-text-opacity, 1));
}
.group:hover .dark\\:group-hover\\:text-primary-dark:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(107 187 177 / var(--tw-text-opacity, 1));
}
.group:hover .dark\\:group-hover\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
@supports (backdrop-filter: var(--tw)) {

  .dark\\:supports-\\[backdrop-filter\\]\\:bg-slate-800\\/60:is(.dark *) {
    background-color: rgb(58 65 111 / 0.6);
  }
}
@media (min-width: 576px) {

  .sm\\:bottom-\\[calc\\(3\\.5rem\\+1\\.5rem\\)\\] {
    bottom: calc(3.5rem + 1.5rem);
  }

  .sm\\:left-auto {
    left: auto;
  }

  .sm\\:right-0 {
    right: 0px;
  }

  .sm\\:right-4 {
    right: 1rem;
  }

  .sm\\:top-4 {
    top: 1rem;
  }

  .sm\\:my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .sm\\:mb-0 {
    margin-bottom: 0px;
  }

  .sm\\:mr-4 {
    margin-right: 1rem;
  }

  .sm\\:mr-6 {
    margin-right: 1.5rem;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:table-cell {
    display: table-cell;
  }

  .sm\\:h-14 {
    height: 3.5rem;
  }

  .sm\\:h-7 {
    height: 1.75rem;
  }

  .sm\\:h-\\[634px\\] {
    height: 634px;
  }

  .sm\\:max-h-\\[634px\\] {
    max-height: 634px;
  }

  .sm\\:min-h-0 {
    min-height: 0px;
  }

  .sm\\:w-14 {
    width: 3.5rem;
  }

  .sm\\:w-\\[440px\\] {
    width: 440px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:max-w-\\[280px\\] {
    max-width: 280px;
  }

  .sm\\:max-w-\\[440px\\] {
    max-width: 440px;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-2 {
    gap: 0.5rem;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:rounded-lg {
    border-radius: 0.5rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:pb-4 {
    padding-bottom: 1rem;
  }

  .sm\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .sm\\:pr-12 {
    padding-right: 3rem;
  }

  .sm\\:pr-4 {
    padding-right: 1rem;
  }

  .sm\\:pt-6 {
    padding-top: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.5rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:leading-3 {
    line-height: 0.75rem;
  }
}
@media (min-width: 768px) {

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:-mt-56 {
    margin-top: -14rem;
  }

  .md\\:mb-0 {
    margin-bottom: 0px;
  }

  .md\\:ml-auto {
    margin-left: auto;
  }

  .md\\:mr-0 {
    margin-right: 0px;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-7 {
    margin-top: 1.75rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:table-cell {
    display: table-cell;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-52 {
    height: 13rem;
  }

  .md\\:w-4\\/12 {
    width: 33.333333%;
  }

  .md\\:w-6\\/12 {
    width: 50%;
  }

  .md\\:w-7\\/12 {
    width: 58.333333%;
  }

  .md\\:w-8\\/12 {
    width: 66.666667%;
  }

  .md\\:flex-0 {
    flex: 0 0 auto;
  }

  .md\\:flex-none {
    flex: none;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:p-10 {
    padding: 2.5rem;
  }

  .md\\:pr-4 {
    padding-right: 1rem;
  }
}
@media (max-width: 768px) {

  .md-max\\:w-full {
    width: 100%;
  }
}
@media (min-width: 992px) {

  .lg\\:-mt-48 {
    margin-top: -12rem;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:ml-0 {
    margin-left: 0px;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-64 {
    height: 16rem;
  }

  .lg\\:w-5\\/12 {
    width: 41.666667%;
  }

  .lg\\:w-6\\/12 {
    width: 50%;
  }

  .lg\\:w-7\\/12 {
    width: 58.333333%;
  }

  .lg\\:w-8\\/12 {
    width: 66.666667%;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:flex-0 {
    flex: 0 0 auto;
  }

  .lg\\:basis-auto {
    flex-basis: auto;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:self-start {
    align-self: flex-start;
  }

  .lg\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:hover\\:text-white\\/75:hover {
    color: rgb(255 255 255 / 0.75);
  }
}
@media (max-width: 992px) {

  .lg-max\\:mt-6 {
    margin-top: 1.5rem;
  }

  .lg-max\\:max-h-0 {
    max-height: 0px;
  }

  .lg-max\\:overflow-hidden {
    overflow: hidden;
  }

  .lg-max\\:bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }

  .lg-max\\:text-slate-700 {
    --tw-text-opacity: 1;
    color: rgb(6 57 34 / var(--tw-text-opacity, 1));
  }

  .lg-max\\:opacity-0 {
    opacity: 0;
  }

  html.dark .lg-max\\:bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(41 37 36 / var(--tw-bg-opacity, 1));
  }

  html.dark .lg-max\\:text-slate-700 {
    --tw-text-opacity: 1;
    color: rgb(222 226 230 / var(--tw-text-opacity, 1));
  }
  html.dark .lg-max\\:bg-white .bg-primary-700 {
    --tw-bg-opacity: 1;
    background-color: rgb(107 187 177 / var(--tw-bg-opacity, 1));
  }

  html.dark .lg-max\\:bg-white .text-primary-600,
  html.dark .lg-max\\:bg-white .text-primary-700 {
    --tw-text-opacity: 1;
    color: rgb(107 187 177 / var(--tw-text-opacity, 1));
  }

  html.dark .lg-max\\:bg-white .border-primary-600 {
    --tw-border-opacity: 1;
    border-color: rgb(107 187 177 / var(--tw-border-opacity, 1));
  }
  html.dark .lg-max\\:bg-white .bg-primary\\/10 {
    background-color: rgb(107 187 177 / 0.2);
  }
}
@media (min-width: 1200px) {

  .xl\\:left-0 {
    left: 0px;
  }

  .xl\\:top-4 {
    top: 1rem;
  }

  .xl\\:-mx-0 {
    margin-left: -0px;
    margin-right: -0px;
  }

  .xl\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .xl\\:my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .xl\\:ml-24 {
    margin-left: 6rem;
  }

  .xl\\:ml-68\\.5 {
    margin-left: 17.125rem;
  }

  .xl\\:ml-auto {
    margin-left: auto;
  }

  .xl\\:mr-0 {
    margin-right: 0px;
  }

  .xl\\:mr-12 {
    margin-right: 3rem;
  }

  .xl\\:mr-4 {
    margin-right: 1rem;
  }

  .xl\\:inline-flex {
    display: inline-flex;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:min-h-\\[calc\\(100vh-2rem\\)\\] {
    min-height: calc(100vh - 2rem);
  }

  .xl\\:w-24 {
    width: 6rem;
  }

  .xl\\:w-4\\/12 {
    width: 33.333333%;
  }

  .xl\\:w-62\\.5 {
    width: 15.625rem;
  }

  .xl\\:max-w-24 {
    max-width: 6rem;
  }

  .xl\\:max-w-62\\.5 {
    max-width: 15.625rem;
  }

  .xl\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:justify-start {
    justify-content: flex-start;
  }

  .xl\\:justify-center {
    justify-content: center;
  }

  .xl\\:bg-transparent {
    background-color: transparent;
  }

  .xl\\:p-2\\.5 {
    padding: 0.625rem;
  }

  .xl\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .xl\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .dark\\:xl\\:bg-transparent:is(.dark *) {
    background-color: transparent;
  }
}
.\\[\\&\\>\\*\\:first-child\\]\\:mt-0>*:first-child {
  margin-top: 0px;
}
.\\[\\&\\>\\*\\:first-child\\]\\:mt-0\\.5>*:first-child {
  margin-top: 0.125rem;
}
.\\[\\&\\>\\*\\:last-child\\]\\:mb-0>*:last-child {
  margin-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./src/styles/tailwind.css","<no source>"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,mCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,mCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;;;IAAA,YAAc;EAAA;;EAAd;EAAA,kBAAc;EAAd,4DAAc;EAAd,oBAAc;EAAd;AAAc;;EAAd;IAAA,yBAAc;IAAd,oBAAc;IAAd,mDAAc;EAAA;;EAAd;IAAA,kBAAc;EAAA;;EAAd,qDAAc;EAAd;IAAA,yBAAc;IAAd,oBAAc;IAAd,mDAAc;EAAA;AACd;EAAA,WAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;AAAoB;AAApB;EAAA,cAAoB;EAApB,SAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,kBAAoB;EAApB,gBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,oBAAoB;EAApB;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,mBAAoB;EAApB;AAAoB;AAApB;EAAA,iBAAoB;EAApB;AAAoB;AAApB;EAAA,kBAAoB;EAApB;AAAoB;AAApB;EAAA,eAAoB;EAApB;AAAoB;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AA0BjB,gGAAgG;AAE9F;EAAA,kBAAe;EAAf;AAAe;AAAf;EAAA,kBAAe;EAAf;AAAe;AAAf;EAAA,kBAAe;EAAf;AAAe;AAAf;;EAAA,oBAAe;EAAf;AAAe;AAAf;EAAA,sBAAe;EAAf;AAAe;AAAf;EAAA;AAAe;AAIf;EAAA;AAAsB;AAItB;EAAA,kBAAmB;EAAnB;AAAmB;AAGrB;IACE,yBAAyB;EAC3B;AAGE;EAAA,oBAAqB;EAArB;AAAqB;AAIrB;EAAA,oBAAqB;EAArB;AAAqB;AAIrB;EAAA,oBAAqB;EAArB;AAAqB;AAIrB;EAAA,oBAAoB;EAApB;AAAoB;AAIpB;EAAA,sBAAsB;EAAtB;AAAsB;AAItB;EAAA,sBAAsB;EAAtB;AAAsB;AAItB;EAAA,sBAAsB;EAAtB;AAAsB;AAItB;EAAA;AAAkB;AAIlB;EAAA;AAAkB;AAIlB;EAAA,kBAAmB;EAAnB;AAAmB;AAInB;EAAA,kBAAmB;EAAnB;AAAmB;AAGrB,6GAA6G;AAE3G;EAAA,kBAAqB;EAArB;AAAqB;AAKrB;;EAAA,oBAAuB;EAAvB;AAAuB;AAIvB;EAAA,sBAAyB;EAAzB;AAAyB;AAG3B,mEAAmE;AAEjE;EAAA;AAAyB;AAG3B,wDAAwD;AACxD;IACE,qBAAqB;IACrB,qDAAqD,EAAE,kBAAkB;EAC3E;AAEA;IACE,WAAW;EACb;AAEA;IACE,uBAAuB;EACzB;AAEA;IACE,0CAA0C;IAC1C,qBAAqB;IACrB,6BAA6B;IAC7B,4BAA4B;EAC9B;AAEA;IACE,2CAA2C;EAC7C;AAEA;IACE,sDAAsD,EAAE,kBAAkB;EAC5E;AAEA;IACE,2CAA2C;EAC7C;AAEA;IACE,2CAA2C;EAC7C;;AArHF,4FAA4F;AA1B5F;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,qBAgJC;EAhJD;AAgJC;AAhJD;EAAA,qBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAlGG;EAAA,oBAAqB;EAArB;AAAqB;AA9CzB;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AA1FG;EAAA,oBAAqB;EAArB;AAAqB;AAtDzB;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,iBAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD,qBAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD,iDAgJC;EAhJD,gEAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD,wBAgJC;EAhJD,wDAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,gBAgJC;EAhJD;AAgJC;AAhJD;EAAA,qBAgJC;EAhJD;AAgJC;AA3GC;ICrCF,2BAAA;IDsCI,kBAAmB;IAAnB,yDAAmB;EACrB;AAmDA;IC1FF,2BAAA;ID2FI,kBAAqB;IAArB,4DAAqB;EACvB;AAEA;;IC9FF,2BAAA;IDgGI,oBAAuB;IAAvB,mDAAuB;EACzB;AAEA;ICnGF,2BAAA;IDoGI,sBAAyB;IAAzB,4DAAyB;EAC3B;AAGA;ICxGF,2BAAA;IDyGI,wCAAyB;EAC3B;AA1GF;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,4DAgJC;EAhJD,kEAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD,2BAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,6EAgJC;EAhJD,iGAgJC;EAhJD;AAgJC;AAhJD;EAAA,0CAgJC;EAhJD,uDAgJC;EAhJD;AAgJC;AAhJD;EAAA,0EAgJC;EAhJD,iGAgJC;EAhJD;AAgJC;AAvGC;IACE,yBAAyB;EAC3B;AAGE;EAAA,oBAAqB;EAArB;AAAqB;AAIrB;EAAA,oBAAqB;EAArB;AAAqB;AAQrB;EAAA,oBAAoB;EAApB;AAAoB;AAiCpB;EAAA,kBAAqB;EAArB;AAAqB;AAKrB;EAAA,oBAAuB;EAAvB;AAAuB;AAAvB;;EAAA,oBAAuB;EAAvB;AAAuB;AAhG3B;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,8BAgJC;EAhJD,qDAgJC;EAhJD;AAgJC;AAhJD;EAAA,8BAgJC;EAhJD;AAgJC;AAhJD;EAAA,2GAgJC;EAhJD,yGAgJC;EAhJD;AAgJC;AAhJD;EAAA,2GAgJC;EAhJD,yGAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,+BAgJC;EAhJD,wDAgJC;EAhJD;AAgJC;AA1GG;EAAA,kBAAmB;EAAnB;AAAmB;AAqDnB;EAAA,kBAAqB;EAArB;AAAqB;AAKrB;;EAAA,oBAAuB;EAAvB;AAAuB;AAIvB;EAAA,sBAAyB;EAAzB;AAAyB;AAKzB;EAAA;AAAyB;AAzG7B;EAAA,kBAgJC;EAhJD,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhDG;EAAA,oBAAuB;EAAvB;AAAuB;AAhG3B;;EAAA;IAAA;EAgJC;AAAA;AAhJD;;EAAA;IAAA;EAgJC;AAAA;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,4DAgJC;EAhJD,mEAgJC;EAhJD;AAgJC;AAhJD;EAAA,mEAgJC;EAhJD;AAgJC;AAhJD;EAAA,sEAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,2BAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,qCAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AA9FG;EAAA,oBAAqB;EAArB;AAAqB;AAIrB;EAAA,oBAAqB;EAArB;AAAqB;AAqCrB;EAAA,kBAAqB;EAArB;AAAqB;AAcrB;EAAA;AAAyB;AAzG7B;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,0BAgJC;EAhJD,oBAgJC;EAhJD;AAgJC;AA3FC;ICrDF,2BAAA;IDsDI,oBAAqB;IAArB,mDAAqB;EACvB;AAvDF;EAAA;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhDG;;EAAA,oBAAuB;EAAvB;AAAuB;AAhG3B;EAAA,sBAgJC;EAhJD;AAgJC;AAhJD;EAAA,kBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;EAAA,oBAgJC;EAhJD;AAgJC;AAhJD;;EAAA;IAAA;EAgJC;AAAA;AAhJD;;EAAA;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA,gBAgJC;IAhJD;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA,kBAgJC;IAhJD;EAgJC;;EAhJD;IAAA,oBAgJC;IAhJD;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA,mBAgJC;IAhJD;EAgJC;;EAhJD;IAAA,mBAgJC;IAhJD;EAgJC;;EAhJD;IAAA,kBAgJC;IAhJD;EAgJC;;EAhJD;IAAA;EAgJC;AAAA;AAhJD;;EAAA;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;AAAA;AAhJD;;EAAA;IAAA;EAgJC;AAAA;AAhJD;;EAAA;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA,oBAgJC;IAhJD;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;AAAA;AAhJD;;EAAA;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA,kBAgJC;IAhJD;EAgJC;;EAhJD;IAAA,oBAgJC;IAhJD;EAgJC;;EAhJD;IAAA;EAgJC;;EA1GG;IAAA,kBAAmB;IAAnB;EAAmB;;EAQnB;IAAA,oBAAqB;IAArB;EAAqB;EA6CrB;IAAA,kBAAqB;IAArB;EAAqB;;EAKrB;;IAAA,oBAAuB;IAAvB;EAAuB;;EAIvB;IAAA,sBAAyB;IAAzB;EAAyB;EAKzB;IAAA;EAAyB;AAuC5B;AAhJD;;EAAA;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA,iBAgJC;IAhJD;EAgJC;;EAhJD;IAAA,mBAgJC;IAhJD;EAgJC;;EAhJD;IAAA,gBAgJC;IAhJD;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA,qBAgJC;IAhJD;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA;EAgJC;;EAhJD;IAAA,kBAgJC;IAhJD;EAgJC;;EAhJD;IAAA,oBAgJC;IAhJD;EAgJC;;EAhJD;IAAA;EAgJC;AAAA;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC;AAhJD;EAAA;AAgJC","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  html,\n  body,\n  #root {\n    height: 100%;\n  }\n\n  body {\n    @apply bg-gray-50 text-slate-500;\n  }\n\n  html.dark {\n    color-scheme: dark;\n  }\n\n  /* Avoid the stone-900 (#1C1917) look for dark mode */\n  html.dark body {\n    background-color: #0b0f0e;\n    @apply text-slate-200;\n  }\n}\n\n/* Pragmatic dark-mode defaults for common light-only utility classes used across the app. */\n@layer utilities {\n  /* Dashboard card surface: white in light mode, fully transparent in dark mode (uses body bg). */\n  .dashboard-card {\n    @apply bg-white;\n  }\n\n  html.dark .dashboard-card {\n    @apply bg-stone-800/30;\n  }\n\n  html.dark .bg-white {\n    @apply bg-stone-800;\n  }\n\n  html.dark .bg-gray-50 {\n    background-color: #0b0f0e;\n  }\n\n  html.dark .text-slate-700 {\n    @apply text-slate-100;\n  }\n\n  html.dark .text-slate-600 {\n    @apply text-slate-200;\n  }\n\n  html.dark .text-slate-500 {\n    @apply text-slate-300;\n  }\n\n  html.dark .text-gray-700 {\n    @apply text-gray-100;\n  }\n\n  html.dark .border-gray-100 {\n    @apply border-gray-700;\n  }\n\n  html.dark .border-gray-200 {\n    @apply border-gray-700;\n  }\n\n  html.dark .border-gray-300 {\n    @apply border-gray-600;\n  }\n\n  html.dark .bg-white\\/70 {\n    @apply bg-white/10;\n  }\n\n  html.dark .hover\\:bg-white\\/60:hover {\n    @apply bg-white/10;\n  }\n\n  html.dark .hover\\:bg-slate-100:hover {\n    @apply bg-stone-700;\n  }\n\n  html.dark .hover\\:bg-gray-50:hover {\n    @apply bg-stone-700;\n  }\n\n  /* Brand green on dark cards: bump \"primary\" surfaces to the brighter mint variant so they don't disappear. */\n  html.dark .bg-white .bg-primary-700 {\n    @apply bg-primary-800;\n  }\n\n  html.dark .bg-white .text-primary-600,\n  html.dark .bg-white .text-primary-700 {\n    @apply text-primary-800;\n  }\n\n  html.dark .bg-white .border-primary-600 {\n    @apply border-primary-800;\n  }\n\n  /* Subtle primary tints: make them visible on dark card surfaces. */\n  html.dark .bg-white .bg-primary\\/10 {\n    @apply bg-primary-dark/20;\n  }\n\n  /* Scrollbar styling (applied via .clicklaw-scrollbar) */\n  .clicklaw-scrollbar {\n    scrollbar-width: thin;\n    scrollbar-color: rgba(148, 163, 184, 0.7) transparent; /* slate-400-ish */\n  }\n\n  .clicklaw-scrollbar::-webkit-scrollbar {\n    width: 10px;\n  }\n\n  .clicklaw-scrollbar::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  .clicklaw-scrollbar::-webkit-scrollbar-thumb {\n    background-color: rgba(148, 163, 184, 0.6);\n    border-radius: 9999px;\n    border: 3px solid transparent;\n    background-clip: content-box;\n  }\n\n  .clicklaw-scrollbar::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(148, 163, 184, 0.85);\n  }\n\n  html.dark .clicklaw-scrollbar {\n    scrollbar-color: rgba(203, 213, 225, 0.45) transparent; /* slate-200-ish */\n  }\n\n  html.dark .clicklaw-scrollbar::-webkit-scrollbar-thumb {\n    background-color: rgba(203, 213, 225, 0.35);\n  }\n\n  html.dark .clicklaw-scrollbar::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(203, 213, 225, 0.55);\n  }\n}",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
